import PageAbstract from '../PageAbastract'
import store from '@/store'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import strUtils from '@/utils/StrUtils'

const isZh = store.getters.language === 'zh'

export default class SeaBookingVirtualHbl extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'txtQuantitySum': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => {
          this.formData.txtQuantitySum = ''
          if (this.formData.packing) {
            const packing = getObjectByCache(TYPE_NAMES.basic_data_Packing, 'code', this.formData.packing)
            if (packing) {
              this.formData.txtQuantitySum = strUtils.jsdx(this.formData.quantity, packing.name)
            }
          }
        }
        this.joinFieldWatchList('packing', callback)
        this.joinFieldWatchList('quantity', callback)
        callback()
        break
      }
      case 'etd': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'freightTermHBL': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'blNumber': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'dispatchingPlaceCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/dispatchingPlaceCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'loadingPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/loadingPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'dischargingPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/dischargingPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'destinationPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/destinationPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'lblCfrState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'billLadingIssued': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'paymentPlaceBL': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'signPlaceBL': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }
}
